define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AdminService = void 0;
    class AdminService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("Admin", httpProtocol, hostName, serviceName, proxyUrl);
        }
        logErrorWithSupport(errorId, host, serviceName, serviceMethod, errorMessage, errorCode, stacktrace, inputParameters, base64Image, userComment) {
            let p = {};
            p.errorId = errorId;
            p.host = host;
            p.serviceName = serviceName;
            p.serviceMethod = serviceMethod;
            p.errorMessage = errorMessage;
            p.errorCode = errorCode;
            p.stacktrace = stacktrace;
            p.inputParameters = inputParameters;
            p.base64Image = base64Image;
            p.userComment = userComment;
            return this.post("LogErrorWithSupport", p, (json) => {
                return json;
            });
        }
        refreshMapReportLayerDatasources() {
            let p = {};
            return this.post("RefreshMapReportLayerDatasources", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.AdminService = AdminService;
});
